import { type ReactNode } from "react";

export function SectionHeader({ icon, label }: { icon: ReactNode; label: string }) {
  return (
    <div className="flex items-center gap-1.5 text-xs font-semibold text-muted-foreground uppercase tracking-wide mt-3 mb-2 border-b border-border pb-1">
      {icon}
      {label}
    </div>
  );
}
